import { Component, ViewChild, ElementRef, AfterViewInit, OnChanges, OnDestroy, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-barcode',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<svg #barcodeEl></svg>`
})
export class BarcodeComponent implements AfterViewInit, OnChanges, OnDestroy {
  /*Example Usage:  <app-barcode [value]="'123456789012'" [format]="'EAN13'"></app-barcode> */
  @ViewChild('barcodeEl', { static: true }) barcodeEl!: ElementRef<SVGSVGElement>;
  @Input() value: string = '';
  @Input() format: string = 'CODE128';

  private destroyed = false;

  ngAfterViewInit() {
    this.render();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] && !changes['value'].firstChange) {
      this.render();
    }
  }

  ngOnDestroy() {
    this.destroyed = true;
  }

  private async render() {
    if (!this.value) {
      // optionally clear or hide
      return;
    }
    try {
      const { default: JsBarcode } = await import(/* webpackChunkName: "jsbarcode" */ 'jsbarcode');
      if (this.destroyed) return;
      JsBarcode(this.barcodeEl.nativeElement, this.value, {
        format: this.format,
        lineColor: "#000",
        displayValue: true,
        width: 2,
        height: 50
      });
    } catch (error) {
      if (!environment.production) {
        console.error('Failed to load JsBarcode:', error);
      }
    }
  }
}
